import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import qs from 'qs';
/**
 * Login page query persistence, shared by all Jove apps (CMS / dashboard / website).
 *
 * The login page context (portal branding via `loginSource`/`slug`, hosting `systemSource`, prefilled `email`)
 * must survive logout so the user lands back on the same login page variant they entered through.
 * One-time action params (`token`, `handleSource`) are intentionally excluded so stale flows are not replayed.
 * Stored in localStorage to match the lifetime of the auth session: sessionStorage dies with the tab,
 * so a returning user with a still-valid session would lose the context on logout.
 * This key is not part of the auth cleanup list in `removeAllAuthKeys`, so it survives logout on purpose.
 */

export var JOVE_LOGIN_PAGE_QUERY_KEY = 'jove-login-page-query';
var PERSISTED_LOGIN_PAGE_QUERY_KEYS = ['loginSource', 'slug', 'systemSource', 'email'];

var pickLoginPageQuery = function pickLoginPageQuery(query) {
  var picked = {};
  PERSISTED_LOGIN_PAGE_QUERY_KEYS.forEach(function (key) {
    var value = query === null || query === void 0 ? void 0 : query[key];

    if (value !== undefined && value !== null && value !== '') {
      picked[key] = value;
    }
  });
  return picked;
};
/** Mirrors the latest login page URL context; a visit without any of the tracked params clears the stored context so a plain /login visit resets it */


export var saveLoginPageQuery = function saveLoginPageQuery(query) {
  if (false) return;
  var picked = pickLoginPageQuery(query);

  if (Object.keys(picked).length > 0) {
    window.localStorage.setItem(JOVE_LOGIN_PAGE_QUERY_KEY, JSON.stringify(picked));
  } else {
    window.localStorage.removeItem(JOVE_LOGIN_PAGE_QUERY_KEY);
  }
};
export var getPersistedLoginPageQuery = function getPersistedLoginPageQuery() {
  if (false) return {};

  try {
    return JSON.parse(window.localStorage.getItem(JOVE_LOGIN_PAGE_QUERY_KEY) || '{}') || {};
  } catch (_) {
    return {};
  }
};
/** Builds the login page URL with the persisted login context restored; the given query takes precedence */

export var buildLoginPageUrl = function buildLoginPageUrl(query) {
  var params = _objectSpread(_objectSpread({}, getPersistedLoginPageQuery()), query || {});

  return "/login".concat(Object.keys(params).length > 0 ? "?".concat(qs.stringify(params)) : '');
};
/** Jumps back to the page the user was on before being sent to the login page (stored by loginWithRedirect) */

export var jumpToLoginReturnUrl = function jumpToLoginReturnUrl() {
  var returnTo = window.sessionStorage.getItem('jove-returnTo');
  window.sessionStorage.removeItem('jove-returnTo');
  window.location.assign(returnTo || '/');
};